import { SxProps } from "@mui/material";

export const wrapperMain: SxProps = {
  "& .coin-row": {
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
    borderRadius: "8px",
    padding: "0 8px",
    "&:hover": {
      background: "rgba(60,70,119,0.9)",
    },
  },
  "& .coin-icon": {
    width: "32px",
    height: "32px",
  },
  "& h6 img": {
    position: "relative",
    left: "8px",
    top: "7px",
  },
  "&>div:first-of-type": {
    width: "478px",
    maxWidth: "100%",
    margin: "0 auto",
  },
};
export const wrapperToken: SxProps = {
  display: "flex",
  justifyContent: "center",
  "& h5": {
    fontWeight: "700",
  },
  "&>div": {
    position: "absolute !important",
    top: "27px",
    right: "13px",
    "& .MuiStack-root": {
      right: "-30.5px",
      top: "3px",
    },
  },
  "&>button": {
    position: "absolute",
    color: "#ffffff",
    top: "28px",
    left: "13px",
  },
};

export const wrapperTopPart: SxProps = {
  textAlign: "center",
  "&>div": {
    display: "flex",
    justifyContent: "center",
    "&>div": {
      borderRadius: "8px",
      margin: "5px",
      minWidth: "101px",
      "& img": {
        width: "32px",
        height: "32px",
      },
      "& h6": {
        fontSize: "1rem",
      },
    },
  },
};

export const wrapperLine: SxProps = {
  border: "1px solid",
  borderImage:
    "radial-gradient(69.42% 18736.31% at 50% 100%, rgba(63, 65, 111, 0) 0%, #FFFFFF 100%) 1",
  width: "100%",
  height: "1px",
  textAlign: "center",
  fontSize: "1.2rem",
  fontWeight: "700",
  "& span": {
    marginTop: "-13px",
    display: "block",
  },
};

export const wrapperNotif: SxProps = {
  display: "flex",
  color: "#9CA3AF",
  "& button": {
    padding: "0 5px 0 0",
    color: "#9CA3AF",
  },
};

export const wrapperCoins: SxProps = {
  justifyContent: "space-between",
  "& img": {
    borderRadius: "50%",
  },
};

export const wrapperItem: SxProps = {
  justifyContent: "space-between",
  width: "49%",
  "& p": {
    fontSize: "1rem",
  },
  "& h6": {
    fontWeight: "700",
    fontSize: "1.4rem",
  },
  "& h5": {
    fontWeight: "700",
    fontSize: "22px",
  },
};
